import { render, staticRenderFns } from "./regist.vue?vue&type=template&id=0f63ab12&scoped=true&"
import script from "./regist.vue?vue&type=script&lang=js&"
export * from "./regist.vue?vue&type=script&lang=js&"
import style0 from "./regist.vue?vue&type=style&index=0&id=0f63ab12&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f63ab12",
  null
  
)

export default component.exports